import { DELETE_FORM_LINK_ERROR } from './';

export default error => dispatch =>
  dispatch({ type: DELETE_FORM_LINK_ERROR, payload: { error } });
